import React from 'react';

// React Router Dom
import { Link } from 'react-router-dom';

// SVGs
import briefcase from '../../assets/images/briefcase.svg';
import cricket from '../../assets/images/cricket.svg';
import gym from '../../assets/images/gym.svg';
import tea from '../../assets/images/mug-hot-alt.svg';
import plate from '../../assets/images/plate-utensils.svg';
import running from '../../assets/images/running.svg';
import mic from '../../assets/images/stage_14644498.svg';
import audit from '../../assets/images/stage-theatre_14644630.svg';
import hall from '../../assets/images/Group.svg';
import dance from '../../assets/images/ballet-dance_16304821.svg';
import handsake from '../../assets/images/handshake 1.svg';
import film from '../../assets/images/photo-film-music_7931217.svg';
import plots from '../../assets/images/stage-concert_14644494.svg';
import user from '../../assets/images/User.svg';

// Local Components
import Divider from '../FormFields/Separator';
import SearchBar from '../FormFields/Searchbar';

// Typography
import { H4, Body2, H3 } from '../../themes/typography';

// CSS Styles
import '../../styles/components/VenueSelection.css';

export default function VenueCircle() {
    return (
        <div className="main-venue-selection-container">
            <H3 color="#f8a21e" fontWeight={600}>
                Explore Venues For Your Next Outings
            </H3>

            <div className="venue-search-bar">
                <SearchBar />
            </div>

            {/* <Divider /> */}

            <div className="venue-selection-container">
                <H4 color="#f8a21e" fontWeight={600}>
                    Explore By Category
                </H4>

                <div className="venue-circle-card">
                    <Link to="/food-and-drinks">
                        <div className="venue-selection-box">
                            <div className="venue-selection-image">
                                <img src={plate} alt="SVG" />
                                <img src={tea} alt="SVG" />
                            </div>

                            <div className="venue-label">
                                <Body2>Food & Drinks</Body2>
                            </div>
                        </div>
                    </Link>

                    <Link to="/sports-and-fitness">
                        <div className="venue-selection-box">
                            <div className="venue-selection-image">
                                <img src={cricket} alt="SVG" />
                                <img src={gym} alt="SVG" />
                                <img src={running} alt="SVG" />
                            </div>
                            <div className="venue-label">
                                <Body2>Sports & Fitness</Body2>
                            </div>
                        </div>
                    </Link>

                    <Link to="/business-and-professional">
                        <div className="venue-selection-box">
                            <div className="venue-selection-image">
                                <img src={handsake} alt="SVG" />
                                <img src={user} alt="SVG" />
                                <img src={briefcase} alt="SVG" />
                            </div>
                            <div className="venue-label">
                                <Body2>Business & Professionals</Body2>
                            </div>
                        </div>
                    </Link>

                    <Link to="/auditoriums">
                        <div className="venue-selection-box">
                            <div className="venue-selection-image">
                                <img src={audit} alt="SVG" id="hall" />
                            </div>
                            <div className="venue-label">
                                <Body2>Auditoriums</Body2>
                            </div>
                        </div>
                    </Link>

                    <Link to="/studios">
                        <div className="venue-selection-box">
                            <div className="venue-selection-image">
                                <img src={mic} alt="SVG" />
                                <img src={dance} alt="SVG" />
                                <img src={film} alt="SVG" />
                            </div>
                            <div className="venue-label">
                                <Body2>Studios</Body2>
                            </div>
                        </div>
                    </Link>

                    <Link to="/halls">
                        <div className="venue-selection-box">
                            <div className="venue-selection-image">
                                <img src={hall} alt="SVG" id="hall" />
                            </div>
                            <div className="venue-label">
                                <Body2>Halls</Body2>
                            </div>
                        </div>
                    </Link>

                    <Link to="/party-plots">
                        <div className="venue-selection-box">
                            <div className="venue-selection-image">
                                <img src={plots} alt="SVG" id="hall" />
                            </div>
                            <div className="venue-label">
                                <Body2>Party Plots</Body2>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>

            <Divider />
        </div>
    );
}
